import { ReactElement, useMemo } from 'react'
import { Grid } from '@mui/material'
import type { ShearConnectionDTO } from '@api/fastAPI.schemas'
import { Form, TextField, UnitConvertedField } from '@ui/forms'
import { makeShearConnectionSchema, shearConnectionSchema } from './schema'

interface Props {
  id: string
  defaultValues: ShearConnectionDTO
  onSubmit: (values: ShearConnectionDTO) => void
  /** Short names of the other Schubverbinder of the library / project */
  takenShortNames: string[]
}

const ShearConnectionForm = ({
  defaultValues,
  id,
  onSubmit,
  takenShortNames,
}: Props): ReactElement => {
  const validationSchema = useMemo(
    () => makeShearConnectionSchema(takenShortNames),
    [takenShortNames],
  )

  return (
    <Form
      id={id}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      defaultValues={{
        ...shearConnectionSchema.getDefault(),
        ...defaultValues,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <TextField
            label="Name"
            name="name"
            placeholder="Schubverbinder 1"
            data-cy="shear-connection-name"
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="Kurzbezeichnung"
            name="short_name"
            placeholder="SA 01"
            data-cy="shear-connection-short-name"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Kommentar im Export"
            name="export_comment"
            data-cy="shear-connection-comment"
          />
        </Grid>

        <Grid item xs={12}>
          {/* Stored in m, so no conversion -- unlike the resistances below. */}
          <TextField
            label="Abstand"
            name="distance"
            type="number"
            unit="m"
            data-cy="shear-distance"
          />
        </Grid>

        <Grid item xs={6}>
          <UnitConvertedField
            label={
              <>
                R<sub>d</sub> Erdbeben (sehr kurz)
              </>
            }
            name="r_d_earthquake"
            unitLabel="kN"
            data-cy="shear-r_d_earthquake"
          />
        </Grid>
        <Grid item xs={6}>
          <UnitConvertedField
            label={
              <>
                R<sub>d</sub> Wind (kurz/sehr kurz)
              </>
            }
            name="r_d_wind"
            unitLabel="kN"
            data-cy="shear-r_d_wind"
          />
        </Grid>
      </Grid>
    </Form>
  )
}

export default ShearConnectionForm
